import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TuiDialogContext } from '@taiga-ui/core';
import { injectContext } from '@taiga-ui/polymorpheus';
import { BaseResizableComponent } from '@src/app/modules/base';

@Component({
  selector: 'telegram-dialog-confirm-login',
  templateUrl: './dialog-confirm-login.component.html',
  styleUrls: ['./dialog-confirm-login.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogConfirmLoginComponent extends BaseResizableComponent {
  private readonly context = injectContext<TuiDialogContext<boolean>>();

  onLogged() {
    this.context.completeWith(true);
  }
}
